export const OFFLINE_DB_NAME = "calins_offline";
export const OFFLINE_DB_VERSION = 1;

export const CACHEABLE_TABLES = new Set([
  "clients",
  "instruments",
  "technicians",
  "instrument_categories",
  "instrument_subcategories",
  "service_orders",
  "purchase_orders",
  "v_purchase_orders",
  "v_service_orders_enriched",
]);

export const SYNC_POLL_MS = 30000;

